/**
 * One man's file, over whatever screen you are on. Asked for in play: "I should be able to see
 * traits and perks and be able to see a detailed view of the personnel on the theatre map screen
 * and again when I select for a mission."
 *
 * The theatre map's rail was a view only - a bust, a name and a status chip - and the ranger picker
 * showed a dossier but nothing of what the man had actually done. Both now open this, which is the
 * same dossier card and the same service file the PERSONNEL screen shows, so a ranger looks like
 * himself everywhere in the game and the decision to send him is made on the whole of him.
 *
 * A modal, deliberately: choosing a mission or reading the map is where you are, and finding out
 * about a man should not take you somewhere else and make you find your way back.
 */

import type { RangerRecord, ServiceEntry } from '../../../meta/types';
import type { Ctx } from '../context';
import { button } from '../dom';
import { serviceName } from '../text';
import { dialog } from './confirm';
import { dossierCard } from './dossierCard';
import { serviceFile } from './serviceFile';

/** His file from the profile, by id. Missing is not an error: he has simply flown nothing yet. */
export function flightsOf(ctx: Ctx, ranger: RangerRecord): ServiceEntry[] {
  return ctx.api.profile().flights[ranger.id] ?? [];
}

/** Open it. `extra` puts a screen's own action - SELECT, say - beside CLOSE. */
export function openServiceFile(ctx: Ctx, ranger: RangerRecord, extra?: HTMLButtonElement): void {
  const close = (): void => ctx.closeModal();
  const d = dialog(serviceName(ranger), close, 'menu-dialog-wide');
  // The card carries the perks, the traits, the ribbons and the merit bar; the file carries the
  // missions. Between them there is nothing about the man the game knows and does not show.
  d.body.append(dossierCard(ranger, { describe: ctx.describe }));
  d.body.append(serviceFile(flightsOf(ctx, ranger), ctx.describe, ranger.record.missions));
  const ok = button('CLOSE', close);
  if (extra) d.actions.append(extra);
  d.actions.append(ok);
  ctx.openModal({ ...d.modal, initialFocus: () => extra ?? ok });
}
